import React, { useState, useEffect } from 'react';
import './TeamPage.scss';
import horseVideo from '@/assets/videos/quote-background.webm';
import classNames from 'classnames';
import {
    DOWNLOAD_ERROR,
    VIDEO_TEXT_AUTHOR,
    VIDEO_TEXT_STRING1,
    VIDEO_TEXT_STRING2,
    VIDEO_TEXT_STRING3,
    VIDEO_TEXT_STRING4,
    VIDEO_TEXT_STRING5,
} from '@/const/public/team-page';
import { teamPageDataFetch } from '@/services/api/public/team/team-api';
import { TeamItem } from '@/types/public/team-page';
import { TeamMemberCard } from './team-member-card/TeamMemberCard';
import { LinearProgress } from '@mui/material';
import { TeamCategoryDescription } from './team-category-description/TeamCategoryDescription';

export const TeamPage: React.FC = () => {
    const [teamData, setTeamData] = useState<TeamItem[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await teamPageDataFetch();
                const { teamData } = response;
                setTeamData(teamData);
                setError(null);
            } catch {
                setError(DOWNLOAD_ERROR);
                setTeamData([]);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return (
        <div className="team-page-container">
            {error && (
                <div className="error-message" role="alert" style={{ color: 'red', marginBottom: '1rem' }}>
                    {error}
                </div>
            )}

            {loading ? (
                <div className="team-loader">
                    <LinearProgress />
                </div>
            ) : (
                teamData.map((team, index) => (
                    <div
                        key={index}
                        className={classNames('team-section', { 'last-section': index === teamData.length - 1 })}
                    >
                        <div className="team_info">
                            <div className="members-grid">
                                <TeamCategoryDescription team={team} />
                                {team.members.map((member) => (
                                    <TeamMemberCard key={member.id} member={member} />
                                ))}
                            </div>
                        </div>
                    </div>
                ))
            )}

            <div className="video-background-container">
                <video autoPlay muted loop playsInline className="background-video">
                    <source src={horseVideo} type="video/webm" />
                </video>

                <div className="quote-overlay">
                    <p className="video-text">{VIDEO_TEXT_STRING1}</p>
                    <p className="video-text">{VIDEO_TEXT_STRING2}</p>
                    <p className="video-text">{VIDEO_TEXT_STRING3}</p>
                    <p className="video-text">{VIDEO_TEXT_STRING4}</p>
                    <p className="video-text">{VIDEO_TEXT_STRING5}</p>

                    <p className="author">{VIDEO_TEXT_AUTHOR}</p>
                </div>
            </div>
        </div>
    );
};
